(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["co-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('co-hero-toggle')) {
    class CoHeroToggle extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const hero = this.closest('.co-hero');
        this.video = hero ? hero.querySelector('video') : null;
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.ready = true;

        this.update = this.update.bind(this);
        this.video.addEventListener('play', this.update);
        this.video.addEventListener('pause', this.update);

        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            const playing = this.video.play();
            if (playing && playing.catch) playing.catch(() => this.update());
          } else {
            this.video.pause();
          }
        });

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
          this.update();
        } else {
          /* Autoplay kann blockiert sein (z. B. Stromsparmodus) – danach den echten Zustand anzeigen */
          setTimeout(this.update, 2500);
        }
      }

      update() {
        const paused = this.video.paused;
        this.button.classList.toggle('is-paused', paused);
        this.button.setAttribute(
          'aria-label',
          paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause
        );
      }
    }

    customElements.define('co-hero-toggle', CoHeroToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
